// products modules
import axios from 'axios';
import { PRODUCT_GREAT_DEALS_URL, MOBILE_URL, SEARCH_PRODUCT_URL } from '../../api/url.js';
import { CATEGORY_2_URL } from '../../api/url.js';

// initial state
const state = {
}

// actions
const actions = {
  fetchProducts: ({ commit }, data) => axios({ url: `${SEARCH_PRODUCT_URL}${data}`, method: 'GET' }),
};

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js